document.addEventListener('DOMContentLoaded', function() {
    // Referencias a elementos del DOM
    const botonFiltro = document.querySelector('.inicio_boton-filtro');
    const opcionesFiltro = document.querySelector('.inicio_opciones-filtro');
    const enlacesFiltro = document.querySelectorAll('.inicio_opciones-filtro a');
    const categorias = document.querySelectorAll('.inicio_categoria');
    
    // El filtro solo existe cuando hay sucursal seleccionada (no en el selector inicial)
    if (botonFiltro && opcionesFiltro) {
        // Función para togglear el menú de filtros
        botonFiltro.addEventListener('click', function(e) {
            e.stopPropagation();
            opcionesFiltro.classList.toggle('activo');
        });

        // Cerrar menú al hacer click fuera
        document.addEventListener('click', function(e) {
            if (!botonFiltro.contains(e.target) && !opcionesFiltro.contains(e.target)) {
                opcionesFiltro.classList.remove('activo');
            }
        });
    }

    // Funcionalidad de filtrado al hacer click en una opción
    enlacesFiltro.forEach(function(enlace) {
        enlace.addEventListener('click', function(e) {
            e.preventDefault();
            
            // Obtener el tipo de filtro seleccionado
            const filtro = this.getAttribute('data-filter');
            
            // Aplicar filtro
            filtrarProductos(filtro);
            
            // Cerrar el menú después de seleccionar
            opcionesFiltro.classList.remove('activo');
        });
    });

    // Añadir funcionalidad a las categorías
    categorias.forEach(categoria => {
        categoria.addEventListener('click', function() {
            // Quitar clase activo de todas las categorías
            categorias.forEach(c => c.classList.remove('activo'));
            
            // Añadir clase activo a la categoría seleccionada
            this.classList.add('activo');
            
            // Obtener la subcategoría seleccionada
            const subcategoriaSeleccionada = this.getAttribute('data-subcat');
            
            // Filtrar por subcategoría
            filtrarPorSubcategoria(subcategoriaSeleccionada);
        });
    });

    // Configurar scroll horizontal para las categorías
    configurarScrollHorizontal();
});

/**
 * Función para filtrar productos según el criterio seleccionado
 * @param {string} filtro - Criterio de filtrado
 */
function filtrarProductos(filtro) {
    // Verificar que catalogoJS esté disponible
    if (!catalogoJS || !Array.isArray(catalogoJS)) {
        console.error('Error: catalogoJS no está disponible o no es un array');
        return;
    }
    
    // Crear una copia del array para no modificar el original
    let productosFiltrados = [...catalogoJS];
    
    switch (filtro) {
        case 'precio-asc':
            // Ordenar por precio ascendente
            productosFiltrados.sort((a, b) => 
                parseFloat(a.precio) - parseFloat(b.precio)
            );
            break;
            
        case 'precio-desc':
            // Ordenar por precio descendente
            productosFiltrados.sort((a, b) => 
                parseFloat(b.precio) - parseFloat(a.precio)
            );
            break;
            
        case 'nombre-asc':
            // Ordenar alfabéticamente A-Z
            productosFiltrados.sort((a, b) => 
                a.nombre.localeCompare(b.nombre)
            );
            break;
            
        case 'nombre-desc':
            // Ordenar alfabéticamente Z-A
            productosFiltrados.sort((a, b) => 
                b.nombre.localeCompare(a.nombre)
            );
            break;
            
        case 'popular':
            // Si existe una propiedad de popularidad (como total_vendidos), usar esa
            // Si no, podríamos implementar otro criterio
            productosFiltrados.sort((a, b) => {
                const popularidadA = a.total_vendidos ? parseInt(a.total_vendidos) : 0;
                const popularidadB = b.total_vendidos ? parseInt(b.total_vendidos) : 0;
                return popularidadB - popularidadA;
            });
            break;
            
        default:
            // Por defecto, no aplicar ningún filtro
            break;
    }
    
    // Renderizar los productos filtrados
    renderProductos(productosFiltrados);
}

/**
 * Filtra productos por subcategoría
 * @param {string} subcategoria - Subcategoría para filtrar
 */
function filtrarPorSubcategoria(subcategoria) {
    // Verificar que catalogoJS esté disponible
    if (!catalogoJS || !Array.isArray(catalogoJS)) {
        console.error('Error: catalogoJS no está disponible o no es un array');
        return;
    }

    // Si la subcategoría es "Todos", mostrar todos los productos
    if (subcategoria === 'Todos') {
        renderProductos(catalogoJS);
        return;
    }

    // Filtrar productos por la subcategoría seleccionada
    const productosFiltrados = catalogoJS.filter(producto => {
        // Verificar que el producto tenga la propiedad subcategorias
        if (!producto.subcategorias) return false;
        
        // Dividir la cadena de subcategorías en un array
        const subcategoriasArray = producto.subcategorias.split(',')
            .map(subcat => subcat.trim());
        
        // Verificar si la subcategoría seleccionada está en el array
        return subcategoriasArray.includes(subcategoria);
    });

    // Renderizar los productos filtrados
    renderProductos(productosFiltrados);
}

/**
 * Configura el scroll horizontal con compatibilidad para Safari
 */
function configurarScrollHorizontal() {
    const contenedorCategorias = document.querySelector('.inicio_categorias');
    
    if (!contenedorCategorias) return;
    
    // Configuración para desplazamiento con mouse
    let isDown = false;
    let startX;
    let scrollLeft;

    contenedorCategorias.addEventListener('mousedown', (e) => {
        isDown = true;
        startX = e.pageX - contenedorCategorias.offsetLeft;
        scrollLeft = contenedorCategorias.scrollLeft;
    });

    contenedorCategorias.addEventListener('mouseleave', () => {
        isDown = false;
    });

    contenedorCategorias.addEventListener('mouseup', () => {
        isDown = false;
    });

    contenedorCategorias.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - contenedorCategorias.offsetLeft;
        const walk = (x - startX) * 2;
        contenedorCategorias.scrollLeft = scrollLeft - walk;
    });

    // Configuración para desplazamiento con touch
    contenedorCategorias.addEventListener('touchstart', (e) => {
        startX = e.touches[0].pageX - contenedorCategorias.offsetLeft;
        scrollLeft = contenedorCategorias.scrollLeft;
    });

    contenedorCategorias.addEventListener('touchmove', (e) => {
        if (e.touches.length !== 1) return;
        const x = e.touches[0].pageX - contenedorCategorias.offsetLeft;
        const walk = (x - startX) * 2;
        contenedorCategorias.scrollLeft = scrollLeft - walk;
    });
}
